module.exports = __webpack_public_path__ + "static/media/avatar1.15323a5d.png";